import { useSelector } from 'react-redux'
import { languages } from '../../../configs/language'
import { formatVal, isInValidValue } from '../../helpers/value'
import { EMPTY_VALUE } from '../../utils/common'
import { CURRENCY, UNIT } from '../../utils/currency'
import useGetExchangeRates from '../category/useGetExchangeRates'
import { UseI18n } from '../hooks/useI18n'
import { selectCurrency, selectUnit } from './slice'

export const useFormatCurrency = (screen) => {
  const locale = useSelector((state) => state.i18n.locale)
  const currency = useSelector(selectCurrency(screen))
  const unit = useSelector(selectUnit(screen))

  const { exchangeRates } = useGetExchangeRates()
  const multiplier = UNIT[unit].multiplier

  const unitName = UseI18n(UNIT[unit].name)
  const decimalLength =
    currency === CURRENCY.VND && unit === UNIT.SINGLE.unitKey ? 0 : 2

  const formatedUnit =
    locale === languages.en
      ? `${currency + (unit === UNIT.SINGLE.unitKey ? '' : ' ' + unitName)}`
      : `${(unit === UNIT.SINGLE.unitKey ? '' : unitName + ' ') + currency}`

  const getExchangeRate = ({ year, exchangeRateType = 'averageRate' } = {}) => {
    let exchangeRate = 1
    if (exchangeRates.length && currency && unit) {
      const exchange = exchangeRates.find((item) => {
        const currencyCondition = item.currencyCode === currency
        const yearCondition = year ? item.realYear === +year : true
        return currencyCondition && yearCondition
      })
      if (exchange) {
        exchangeRate =
          exchangeRateType.toLowerCase() === 'averagerate'
            ? exchange.averageRate
            : exchange.lastDayRate
      }
    }
    return exchangeRate
  }

  const convertValue = ({ value, year, exchangeRateType }) => {
    if (isInValidValue(value)) return value
    const exchangeRate = getExchangeRate({ year, exchangeRateType })
    return (value / exchangeRate) * multiplier
  }

  const formatCurrency = ({
    value,
    year,
    exchangeRateType,
    isFinancialStatement = false,
  }) => {
    return formatVal(
      convertValue({ value, year, exchangeRateType }),
      locale,
      isFinancialStatement,
      decimalLength,
    )
  }

  const formatCurrencyWithUnit = ({
    value,
    year,
    exchangeRateType,
    isFinancialStatement,
  }) => {
    const formatedValue = formatCurrency({
      value,
      year,
      exchangeRateType,
      isFinancialStatement,
    })

    if (formatedValue === EMPTY_VALUE) return EMPTY_VALUE

    return locale === languages.en
      ? `${currency} ${formatedValue} ${unitName}`
      : `${formatedValue} ${unitName} ${currency}`
  }

  const formatValue = ({ value, isFinancialStatement }) => {
    return formatVal(value, locale, isFinancialStatement, decimalLength)
  }

  const formatValueWithUnit = ({ value, isFinancialStatement }) => {
    const formatedValue = formatValue({ value, isFinancialStatement })

    if (formatedValue === EMPTY_VALUE) return EMPTY_VALUE

    return locale === languages.en
      ? `${currency} ${formatedValue} ${unitName}`
      : `${formatedValue} ${unitName} ${currency}`
  }

  const latestAvgExchangeRate = getExchangeRate()

  return {
    currency,
    multiplier,
    unitName,
    formatedUnit,
    latestAvgExchangeRate,
    decimalLength,
    convertValue,
    getExchangeRate,
    formatCurrency,
    formatCurrencyWithUnit,
    formatValue,
    formatValueWithUnit,
  }
}
